import { CourseType, LessonType } from '../../../types'
import { getCourseLessons } from '.'

// Returns the total running time (in seconds) of all the
// videos within the lessons of the course

export const getCourseVideoLength = (course?: CourseType) => {
  if (!course) {
    return 0
  }

  const allLessons = getCourseLessons(course)

  const totalVideoLength = allLessons.reduce((videoLength: number, lesson: LessonType) => {
    return videoLength + (lesson.video?.duration || 0)
  }, 0)

  return totalVideoLength
}
